// Import the useChat hook directly from the ChatContext file
export { useChat } from '../context/ChatContext';
